import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import SpecificationViewed from "../../component/SepcificationViewed";
import FilePdf from "../../broucherPdf/filePdf";
import uspco2laser from "../../assets/uspco2laser.png";

export default function UspCo2Laser() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [foodAndBeverageVisible, setFoodAndBeverageVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const foodAndBeverageRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Print Technology",
      data: "Continuous Ink Jet",
    },
    {
      title: "Laser Galvanometer",
      data: "High-precision 2D high-speed scanning galvanometers",
    },
    {
      title: "Cooling Method & Dust way",
      data: "Atmospheric air-cooled & Sealed",
    },
    {
      title: "Power Consumption",
      data: "500W-1000W (110VAC, 60HZ)",
    },
    {
      title: "Marking Focal Length",
      data: "100mm-190mm (133mm currently on SQ-10 & SQ-30)",
    },
    {
      title: "Positioning Accuracy",
      data: "0.01mm",
    },
  ];
  const rightSidePrinterSpecification = [
    {
      title: "Laser Wavelength",
      data: "10.6um",
    },
    {
      title: "Software features",
      data: "Counter, lot counter, shift code, time and date, expiration date",
    },
    {
      title: "Marking Speed & Character Size",
      data: "800-1000 characters/second & Adjustable in marking range",
    },
    {
      title: "Marking Line Number",
      data: "Code Rotation - 0 to 360",
    },
    {
      title: "Operating Languages",
      data: "English and Chinese",
    },
    {
      title: "Cabinet Construction",
      data: "Heavy duty cast aluminum",
    },
  ];

  const foodAndBeverage1 = [
    {
      productImg: Images?.industry5,
      label: "Food & Beverage",
      pageNavigate: "/byindustry/foodandbeverage",
    },
    {
      productImg: Images?.industry1,
      label: "Automobile",
      pageNavigate: "/byindustry/automobile",
    },
    {
      productImg: Images?.industry7,
      label: "Pharma",
      pageNavigate: "/byindustry/pharma",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };

  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="USP CO2 LASER"
        printerImg={Images?.uspstream18}
        pdfFile={FilePdf?.usp_CO2_Laser}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            SQ-CO2 Laser Coding System
          </header>
          <div
            ref={printerDetailsRef}
            // className="printerDetailsData"
            className={`printerDetailsData ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            Squid Ink's SQ-10 and SQ-30 laser coding systems are designed for
            high speed food and beverage, pharmaceutical, cosmetic, and other
            primary coding applications. Squid Ink lasers can permanently mark
            onto paper, cardboard, plastic, glass, wood, coated metal, Leather,
            and more. Users select between a 10W(SQ-10) and 30W system(SQ-30)
            depending on their specific application requirements.
          </div>
          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                // className={`youtubeVideo `}
                className={`youtubeVideo ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div className="productImageContainer">
                    <img className="w-[100%]" src={uspco2laser} alt="" />
                  </div>
                  {/* Buttons */}
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.usp_CO2_Laser}
                    download="Usp CO2_LASER"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
